import TrackDocumentAction from "../../dashboard/quick_access/mixins/track_document_action";
import { DomUtils } from "../../../util/DomUtils";
import { ClipboardUtils } from "../../../util/ClipboardUtils";
import { showNotification } from "../../../global";
import { UrlUtil } from "../../../util/UrlUtil";
import { AnnotationSelectionHandler } from "../utils/AnnotationSelectionHandler";

export default {
    mixins: [TrackDocumentAction],
    methods: {
        /**
        * @param {string|null|undefined} existingNoteId - The ID of the existing note (if any).
        * @param {{
        *   sectionId: string,
        *   documentId: string,
        *   isNewIccXml?: boolean,
        *   highlightedText?: string|null
        * }} options - The note options for the modal.
        */
        toggleNoteActionNew(existingNoteId, options){

            EventBus.fire('note-modal', {
                'id': existingNoteId ? existingNoteId : null,
                'sectionId': options.sectionId,
                'documentId': options.documentId,
                'isNewXml': options.isNewIccXml ?? false,
                'highlightedText' : options.highlightedText ?? null
            });
            this.trackClickedAction('Note/Highlight Section');
        },

        /**
        * @param {string|null|undefined} existingBookmarkId - The ID of the existing bookmark (if any).
        * @param {{
        *   sectionTitle: string|null
        *   sectionId: string,
        *   chapterId: string|null,
        *   documentId: string
        * }} options - The bookmark options for the modal.
        */
        toggleBookmarkActionNew(existingBookmarkId, options) {

            EventBus.fire('bookmark-modal', {
                'id': existingBookmarkId ? existingBookmarkId : null,
                'sectionTitle': options.sectionTitle ?? null,
                'sectionId': options.sectionId,
                'chapterId': options.chapterId ?? null,
                'document_id': options.documentId,
            });

            this.trackClickedAction('Bookmark Section');
        },
        copyTextAction(sectionId) {
            const section = document.getElementById(`${AnnotationSelectionHandler.SECTION_WRAPPER_ID_PREFIX}${sectionId}`);
            if (!section) {
                return;
            }
            const clonedSection = section.cloneNode(true);
            // exclude some section like notes, insights, tags, breadcrumb etc
            const artifactsToRemove = clonedSection.querySelectorAll(AnnotationSelectionHandler.REMOVE_SELECTORS_FROM_SELECTION);
            artifactsToRemove.forEach(el => el.remove());

            const wrapperDiv = document.createElement('div');
            wrapperDiv.appendChild(clonedSection);
            ClipboardUtils.copyUsingNativeApi(wrapperDiv)
                .then((successMessage) => {
                    showNotification(successMessage, 'success');
                })
                .catch((errorMessage) => {
                    showNotification(errorMessage, 'error');
                });

        },
        printAction(documentId, sectionId) {
            let tableWidth = 998;
            let printAllSections = false;

            const printUrl = Routing.generate('print_content', {
                'documentId': btoa(documentId),
                'chapterId': btoa(0), // when 0, it will fetch chapterId for you on the backend
                'sectionId': btoa(sectionId),
                'tableWidth': tableWidth,
                'printAll': printAllSections ? 1 : 0,
            });

            window.open(printUrl, '_blank');
        },
        shareLinkAction(sectionId) {
            const sectionLink = Routing.generate('content_id_redirect', {
                'contentId': sectionId
            });

            const fullUrl = UrlUtil.relativeToAbsolute(sectionLink);

            try {
                ClipboardUtils.copyTextToClipboard(fullUrl);
                showNotification('Link copied to clipboard');
            } catch (e) {
                console.error(e);
                showNotification("Failed to copy to clipboard", "error");
            }
        },
        mobileActionFired(sectionDetails) {
            EventBus.fire('show-toolbar-actions-mobile', sectionDetails);
        }
    },
    created() {
        EventBus.listen('toolbar-action-copy-text', (data) => this.copyTextAction(data.sectionId));
        EventBus.listen('toolbar-action-open-note-bookmark-modal', (data) => this.toggleBookmarkActionNew(data));
        EventBus.listen('toolbar-action-print-section', (data) => this.printAction(data.documentId, data.sectionId));
        EventBus.listen('toolbar-action-copy-link', (data) => this.shareLinkAction(data.sectionId));
    },
}